import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { httpService } from '@/api/v1/http.service'

const responseSchema = z.array(
  z.object({
    id: z.string().min(1),
    full_name: z.string().min(1)
  })
)

type Teacher = {
  id: string
  fullName: string
}

const parseResponse = (response: z.infer<typeof responseSchema>): Teacher[] =>
  response.map(item => ({
    id: item.id,
    fullName: item.full_name
  }))

const useTeachers = () =>
  useQuery({
    queryKey: ['panelTeachersList'],
    staleTime: 60 * 100,
    queryFn: async () => {
      const response = await httpService.panel.panelTeachersList({
        page_size: 'max',
        fetchKeys: {
          id: true,
          full_name: true
        }
      })
      const parsedTeachers = parseResponse(
        responseSchema.parse(response.results)
      )

      const options = parsedTeachers.map(teacher => ({
        label: teacher.fullName,
        value: teacher.id
      }))

      const getTeacherName = (id?: string) =>
        parsedTeachers.find(teacher => teacher.id === id)?.fullName

      return {
        options,
        getTeacherName
      }
    }
  })

export default useTeachers
